import Config from '@app/dev/config/main';
import { getOriginalCpf } from '@app/dev/helpers/formatCpfNumber';
import { swarmRequest } from '@common/helpers/util/requestMiddleware';

const CpfHandlers = {
  cpf: async (cpf) => {
    const data = await swarmRequest({ cpf: getOriginalCpf(cpf) }, 'validate_cpf');
    return data;
  },
  cpfs: async (cpf) => {
    const { details, result_text: errorMessage, result: status } = await swarmRequest({ cpf: getOriginalCpf(cpf) }, 'get_client_information_by_consultas_prime_cpf');

    if (status === 0) {
      const [first, ...rest] = details.Nome.split(' ');

      const data = {
        FirstName: first,
        LastName: rest.join(' '),
        BirthDate: details.DataNascimento,
      };

      return data;
    }

    return { errorMessage };
  },
};

export const validateCpf = (cpf) => CpfHandlers[Config.main.cpfType](cpf);

export function isValidCPF(cpf) {
  // Remove non-numeric characters
  cpf = cpf.replace(/[^\d]/g, '');

  // Check if the CPF has exactly 11 digits
  if (cpf.length !== 11) {
    return false;
  }

  // Check if all digits are the same (invalid CPF case)
  if (/^(\d)\1{10}$/.test(cpf)) {
    return false;
  }

  // Validate the first checksum digit
  let sum = 0;
  for (let i = 0; i < 9; i++) {
    sum += parseInt(cpf.charAt(i)) * (10 - i);
  }
  let firstDigit = 11 - (sum % 11);
  if (firstDigit === 10 || firstDigit === 11) {
    firstDigit = 0;
  }
  if (parseInt(cpf.charAt(9)) !== firstDigit) {
    return false;
  }

  // Validate the second checksum digit
  sum = 0;
  for (let i = 0; i < 10; i++) {
    sum += parseInt(cpf.charAt(i)) * (11 - i);
  }
  let secondDigit = 11 - (sum % 11);
  if (secondDigit === 10 || secondDigit === 11) {
    secondDigit = 0;
  }
  if (parseInt(cpf.charAt(10)) !== secondDigit) {
    return false;
  }

  return true;
}